import AlertModalActions from '../actions/A_ongoing_call_ivr_modal'

const initalState = {
  isModalOpen: false,
  data: {}
};

const OngoingCallIvrModalReducer = (state = initalState, action) => {
  const { type, payload } = action;

  switch (type) {
    case AlertModalActions.types.ONGOING_CALL_IVR_MODAL_SHOW:
      return { isModalOpen: true, data: {...payload} };

    case AlertModalActions.types.ONGOING_CALL_IVR_MODAL_HIDE:
      return { isModalOpen: false, data: {} };

    default:
      return state;
  }
};

export default OngoingCallIvrModalReducer;


// WEBPACK FOOTER //
// ./src/redux/reducers/reducer_ongoing_call_ivr_modal.js